import {
  GetSeasonMatches as GetSeasonMatchesAction,
  GetSeasonMatchesPayload,
} from "../../providers/supabase-provider/actions/GetSeasonMatches";
import type { IGameView } from "../../entities";

export { GetSeasonMatchesPayload };

export const GetSeasonMatches = async (payload: GetSeasonMatchesPayload): Promise<IGameView[]> => {
  return await GetSeasonMatchesAction(payload);
};
